export const colors = [
  {
    bg: "#0084FF",
    font: "#FFFFFF",
    border: "#7fc1ff"
  },
  {
    bg: "#FF6161",
    font: "#FFFFFF",
    border: "#ffb0b0"
  },
  {
    bg: "#66C854",
    font: "#FFFFFF",
    border: "#b2e3a9"
  },
  {
    bg: "#FFC300",
    font: "#FFFFFF",
    border: "#ffe17f"
  },
  {
    bg: "#18B1A8",
    font: "#FFFFFF",
    border: "#77ece5"
  },
  {
    bg: "#A2A2A2",
    font: "#FFFFFF",
    border: "#d0d0d0"
  },
  {
    bg: "#1E3E72",
    font: "#FFFFFF",
    border: "#6e96d8"
  },
  {
    bg: "#D88DBC",
    font: "#FFFFFF",
    border: "#ebc6dd"
  },
  {
    bg: "#63C8F2",
    font: "#FFFFFF",
    border: "#b1e3f8"
  },
  {
    bg: "#D3D3D3",
    font: "#000000",
    border: "#e9e9e9"
  },
  {
    bg: "#CEFFCC",
    font: "#000000",
    border: "#e6ffe5"
  },
  {
    bg: "#000000",
    font: "#FFFFFF",
    border: "#7f7f7f"
  }
];
export const inactivity = {
  redirectSeconds: 2700,
  warningSeconds: 1800
  // redirectSeconds: 20,
  // warningSeconds: 10
};
